const STORAGE_KEY = 'pcp_attribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

// Runs once at module load — imported for its side effect at the very top
// of main.jsx, before React renders anything. This has to happen before
// ProtectedRoute's <Navigate to="/login" /> (which drops the query string
// entirely for anonymous visitors), so it can't live in a useEffect: React
// commits child effects before parent effects, and that redirect wins the
// race every time.
(function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');

    const utms = {};
    let hasUtm = false;
    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) {
        utms[key] = value;
        hasUtm = true;
      }
    });

    let fbc;
    if (fbclid) {
      fbc = `fb.1.${Date.now()}.${fbclid}`;
      const maxAge = 60 * 60 * 24 * 90; // 90 days, matches Meta's own _fbc/_fbp lifetime
      document.cookie = `_fbc=${fbc}; path=/; max-age=${maxAge}; SameSite=Lax`;
    }

    if (hasUtm || fbclid) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...utms,
        fbclid: fbclid || undefined,
        fbc,
        captured_at: new Date().toISOString(),
      }));
    }
  } catch (error) {
    console.error('[attribution] Failed to capture campaign params:', error);
  }
})();

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null') || {};
  } catch {
    return {};
  }
}
